export const APP_VERSION = '3.7.0';
